module.exports = __webpack_public_path__ + "img/festveraologo.66973b9f.png";